import { render, staticRenderFns } from "./RightAlignmentPagination.vue?vue&type=template&id=2cad0517"
import script from "./RightAlignmentPagination.vue?vue&type=script&lang=js"
export * from "./RightAlignmentPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports